export default "__VITE_ASSET__Bo1A5rbT__"